export function truncatedEmail(email: string) {
  return `${email.substring(0, 4)}**@**${email.substring(email.length - 2)}`;
}
